<script>
  import { onMount } from 'svelte';
  import Validate from '../services/validate';
  import { mdiClose } from '@mdi/js';
  import CookiesService from '../services/cookies'
  import GoogleTagManagerService from '../services/tag-manager';
  import LineruTagsService from '../services/lineru-tags';
  import sendEmailApiService from '../services/sendEmail.api';

  let code =""
  const sendEmailService = new sendEmailApiService();
  const pathLineru = PATHLINERU;

  let disableSendEmailBtn = false;

  let status = {
    email: true,
  };
  let errorMessages = {
    email: 'Ingresa un correo válido',
  };

  let fields = [
    {
      id: 'email',
      label: 'Correo electrónico',
      placeholder: 'lineru@lineru.com',
      type: 'input',
      handleStatus: function(e) {
        if (!Validate.required(e.target.value)) {
          errorMessages[this.id] = '';
          status[this.id] = false;
        } else if (!Validate.email(e.target.value)) {
          errorMessages[this.id] = 'Ingresa un correo válido';
          status[this.id] = false;
        } else {
          status[this.id] = true;
        }

        this.value = e.target.value;
      },
      value: ''
    },
  ];

  let checkPermiStatus = false;
  let elCheckPermiStatus;

  let checkPermi = {
    status: true,
    errorMessage: 'Haz clic en Aceptar para confirmar tu permiso de referir y poder envíar el correo.',
    handleStatus: e => {
      let result = e.detail.filter(el => el.checked);
      checkPermiStatus = result.length > 0 ? true : false;
    },
    checks: [
      {
        id: 'checkPermi',
        label: `<span class="t-size-2">Acepto que tengo permiso de referir este contacto y que sea contactado por Lineru con fines comerciales.</span>`,
        value: 'checkPermiChecked',
        checked: false,
      },
    ],
  };

  onMount(async () => {

    const res  = window.location.search;

		const urlParams = new URLSearchParams(res);

    code = urlParams.get('referral_code');

    if(!code){
      window.open(
        pathLineru,
        '_self'
      );
    }

    elCheckPermiStatus.addEventListener('check-change', e => {
      checkPermi.handleStatus(e);
    });

  });

  function formValidate() {
    touched = true;

    fields.forEach(fields => {
      let e = {
        target: {
          value: fields.value,
        },
      };

      fields.handleStatus(e);
    });

    if (!checkPermiStatus) {
      checkPermiStatus = false;
    }

    const valFields = fields.filter(fields => status[fields.id] === true);

    const validateAll = valFields.length === fields.length && checkPermiStatus;

    return validateAll;
  }

  let modal = false;

  function handlerSendEmailsForm(body) {
    let validate = formValidate();
    const cleverToken = CookiesService.getItem('WZRK_G');

    if (!validate) {
      return;
    }

    disableSendEmailBtn = true;

    let data = {
      referral_code: code,
      email: fields.find(fields => fields.id === 'email').value,
      accept_terms: checkPermiStatus,
      // clevertap_Token: cleverToken,
    };

    sendEmailService.sendCode(data).then(() =>{
      document.querySelector(".js-modal");
      modal = true;
      disableSendEmailBtn = false;
    }).catch(() =>{
      modal = false;
      disableSendEmailBtn = true;
    })


    GoogleTagManagerService.setTag(LineruTagsService.general().mailDirect);

    if(clevertap !== undefined) {
      clevertap.event.push("be referred", {
        "referral code": code,
        "zinobe_product_name": "Lineru",
        "identity": "",
      });
    }
  }

  let touched = false;

  function closeModal() {
    modal = false;
    disableSendEmailBtn = true;
  }
</script>

<style>
  .bg-patrones {
    left: 1010px;
    bottom: 33px;
  }
  .p-relative {
    position: relative;
  }
  .p-absolute {
    position: absolute;
  }
  .img_4 {
    left: 250px;
    bottom: 30px;
  }
  .img_4-1 {
    left: 980px;
    bottom: 30px;
  }
  .img_5 {
    top: 50px;
    left: 20px;
  }
  .img_6 {
    top: 250px;
    left: 90px;
  }
  .img_7{
    top: 430px;
    left: 920px;
  }
  .disabled {
    pointer-events:none;
    cursor:not-allowed;
    color:#fff;
    background-color:#cbb8e6;
  }

</style>

<div>
  <div class="p-absolute">
    <img class="p-relative d-block d-md-none img_4" src="images/fold-4/forma-4.png" alt="" />
    <img class="p-relative img_4-1 d-none d-lg-block" src="images/fold-4/forma-4.png" alt="" />
  </div>
  <div class="container">
    <div class="d-grid grid-12 justify-content-center">
      <div class="col-12 col-lg-2">
        <div class="p-absolute">
          <img class="p-relative img_5 d-none d-lg-block" src="images/fold-4/forma-5.png" alt="">
          <img class="p-relative img_6 d-none d-lg-block" src="images/fold-4/forma-6.png" alt="">
        </div>
      </div>
      <div class="col-12 col-lg-8 p-0 p-md-4 mb-10 mb-lg-5">
        <div class="t-lg-center">
          <h4 class="mb-8 pt-lg-8">Opción 3</h4>
          <h2 class="mb-6">Envíalo directo en un correo</h2>
          <p class="t-size-5 mb-8">
            Pasa tu
            <strong>código</strong>
            por correo para compartirlo sin que todos se enteren.
          </p>
        </div>
        <div class="d-flex flex-col px-lg-18">
          {#each fields as field}
            <znb-input
              id={field.id}
              oninput={e => field.handleStatus(e)}
              label={field.label}
              valid={status[field.id]}
              errormessage={errorMessages[field.id]}
              placeholder={field.placeholder}
              maxlength={field.maxlength}
              {touched}
              class="d-block mb-4" />
          {/each}
          <znb-checkbox
            errormessage="{checkPermi.errorMessage}"
            name="mycheckgroup"
            valid={checkPermiStatus}
            options={checkPermi.checks}
            {touched}
            darktheme={false}
            bind:this={elCheckPermiStatus}
            class="mb-8" />
        </div>
        <div class="d-flex justify-content-center">
          <button
            class="btn btn--shadow bgr-primary-500 bgr-brand-2:active t-white btn-lg w-100 w-lg-auto d-flex t-left align-items-center mb-8"
            class:disabled={disableSendEmailBtn}
            role="button"
            aria-labelledby=""
            on:click={handlerSendEmailsForm}>
            <span class="flex-grow">Enviar código</span>
            {#if !disableSendEmailBtn}
            <svg class="ml-3 -mr-3 t-yellow" width="16" height="11"><path
                fill="currentColor"
                d="M15.902 5.257l-5-5.156a.326.326 0 00-.471 0 .351.351 0 000 .486l4.431 4.57H.333A.338.338 0 000 5.5c0 .19.15.344.333.344h14.529l-4.431 4.57a.351.351 0 000 .485.327.327 0 00.471 0l5-5.156a.351.351 0 000-.486z" /></svg>
            <span class="d-none qwerty" />
            {/if}
          </button>
        </div>
      </div>
      <div class="col-12 col-lg-2"/>
      <div class="p-absolute d-flex d-none d-md-block">
        <img class="p-relative img_7 d-none d-xl-block" src="images/fold-4/forma-7.png" alt="">
        <img class="p-relative bg-patrones d-none d-xl-block" src="images/fold-4/patrones-y.png" alt="">
      </div>
    </div>
  </div>
  <div class="js-modal">
    <znb-modal show={modal} dismissible="true" size="sm">
      <div class="d-flex align-items-start">
        <div class="flex-grow-1 w-100 -mr-6">
          <h3 class="t-center mb-5 pr-8 pt-4">
            ¡Listo!
          </h3>
        </div>

        <button
          on:click="{closeModal}"
          class="p-0 bgr-transparent bdr-none -mr-6 t-primary-500 t-primary-500:hover"
          aria-label="Cerrar modal"
        >
          <svg class="w-6 h-auto" viewBox="0 0 24 24">
            <path fill="currentColor" height="100%" d={mdiClose}/>
          </svg>
        </button>
      </div>
      <div class="d-flex flex-col align-items-center">
        <p class="t-size-3 mb-5 pr-5">
          Hemos enviado un correo electrónico a tu referido
          <br class="d-none d-sm-inline">
          con tu código y los pasos que debe realizar para
          <br class="d-none d-sm-inline">
          solicitar su primer desembolso.
        </p>
        <p class="t-size-2 t-weight-bold mb-8">
          * Si tu referido no ve el correo electrónico en la bandeja de
          <br class="d-none d-sm-inline">
          entrada, dile que revise la carpeta de correo no deseado o
          <br class="d-none d-sm-inline">
          la carpeta de SPAM
        </p>
        <button
          on:click={closeModal}
          class="d-block btn btn--shadow bgr-primary-500 bgr-brand-2:active t-white mb-3"
          role="button">
            Entendido
            <svg class="ml-3 -mr-3 t-yellow" width="16" height="11"><path
              fill="currentColor"
              d="M15.902 5.257l-5-5.156a.326.326 0 00-.471 0 .351.351 0 000 .486l4.431 4.57H.333A.338.338 0 000 5.5c0 .19.15.344.333.344h14.529l-4.431 4.57a.351.351 0 000 .485.327.327 0 00.471 0l5-5.156a.351.351 0 000-.486z" /></svg>
        </button>
      </div>
    </znb-modal>
  </div>
</div>
